import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="font-heading text-2xl text-foreground-950 whitespace-nowrap">
                韩漫网
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                韩漫网是专注于韩国漫画的中文在线阅读导航平台，为您提供海量优质韩漫资源，支持免费阅读、实时更新。
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-sm text-foreground-900 mb-4">热门分类</h4>
              <div className="space-y-2">
                {categories.slice(0, 4).map((cat) => (
                  <a key={cat.slug} href={`/category/${cat.slug}`} className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-sm text-foreground-900 mb-4">更多分类</h4>
              <div className="space-y-2">
                {categories.slice(4).map((cat) => (
                  <a key={cat.slug} href={`/category/${cat.slug}`} className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {cat.name}
                  </a>
                ))}
                <a href="/about" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  关于我们
                </a>
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-sm text-foreground-900 mb-4">联系我们</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                如有任何问题或合作意向，欢迎通过以下方式联系我们。
              </p>
              <a href="/about" className="inline-block mt-3 text-sm text-primary-500 hover:text-primary-600 transition-colors">
                了解更多 &rarr;
              </a>
            </div>
          </div>
          <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 韩漫网 - 韩漫网站与漫画韩漫网址。本站所有内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="/about" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">关于我们</a>
              <a href="/about" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">联系方式</a>
              <a href="/about" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">用户协议</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}